// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".first_form label[data-v-2f65a211]{font-weight:500}", ""]);
// Exports
module.exports = exports;
